
/* styles */
require("!!../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-31359386\",\"scoped\":true,\"hasInlineConfig\":false}!../../../vue-loader/lib/selector?type=styles&index=0!./Vuetable.vue")

var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./Vuetable.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-31359386\"}!../../../vue-loader/lib/selector?type=template&index=0!./Vuetable.vue"),
  /* scopeId */
  "data-v-31359386",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vuetable-2/src/components/Vuetable.vue
// module id = 687
// module chunks = 1